import { render, staticRenderFns } from "./RepresentitiveExample.vue?vue&type=template&id=19d35b80"
import script from "./RepresentitiveExample.vue?vue&type=script&lang=js"
export * from "./RepresentitiveExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports